export const SMS = 1;
export const EMAIL = 2;
export const MANUAL = 3;
